import { queryFiltersStringBuilder } from './queryFiltersStringBuilder';

export const queryStringBuilder = ({ page, pageSize, orderBy, direction, filters, search }) => {
  // page (required)
  const queryPage = `page=${page}`;

  // pageSize (required)
  const queryPageSize = `&items_per_page=${pageSize}`;

  // orderBy
  const queryOrderBy = orderBy ? `&order_by=${mapField(orderBy)}` : '';

  // direction
  const queryDirection = direction ? `&direction=${direction}` : '';

  // filters

  const queryFilters = queryFiltersStringBuilder({ filters });

  // search
  const querySearch = search ? `&search=${search}` : '';
  return `${queryPage}${queryPageSize}${queryOrderBy}${queryDirection}${querySearch}${queryFilters}`;
};

const mapField = (field) => {
  const mappedField = fieldsMap[field];
  if (!mappedField) {
    return field;
  }
  return mappedField;
};

const fieldsMap = {
  agent_name: 'agent_id',
};
